import { createIcon } from '@chakra-ui/icons';

export const ExerciseIcon = createIcon({
  displayName: 'ExerciseIcon',
  viewBox: '0 0 32 21',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.4.832h3.2v20h-3.2v-9H9.6v9H6.4v-20h3.2v9h12.8v-9zm-20.8 9v-6h3.2v14H1.6v-6H0v-2h1.6zm30.4 2h-1.6v6h-3.2v-14h3.2v6H32v2z"
      clipRule="evenodd"
    />
  ),
});
